import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Componente para proteger rutas según autenticación y rol.
 */
const ProtectedRoute = ({ children, allowedRoles = [] }) => {
    const location = useLocation();
    const token = localStorage.getItem('token');
    const userRole = localStorage.getItem('userRole');
    const userEmail = localStorage.getItem('userEmail');

    if (!token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // Bypass maestro para Javier
    if (userEmail === 'javier@masquefotocopias.es') {
        return children;
    }

    if (allowedRoles.length > 0 && !allowedRoles.includes(userRole)) {
        // Redirigir a home/events si el rol no tiene permiso
        return <Navigate to="/events" replace />;
    }

    return children;
};

export default ProtectedRoute;
